import { DS_getData } from '../DS/DS.Data'
import { appUploadQueue } from './AppUploadQueue'
import { processUpload } from '../../../app-core/lib/upload/processUpload'
import { ApiClient } from '../../../app-core/lib/util/ApiClient'
import { readChunk } from './fileChunk'
import * as sentry from '../../src/utils/sentry'
import { Cust_httpUrlGet } from '../Cust/Cust.get'
import { isDone, type ProcessableUpload } from '../../../app-core/lib/upload/Upload'
import { Logg_createLogger } from '../Logg/Logg.Logger'
import { Uplo_deleteUploads } from './Uplo.delete'
import { Uplo_resetTransientUploads } from './Uplo.resetTransientUploads'
import { E2E_uploadsProcessed } from '../E2E/E2E.dispatch'

async function processUploads() {
    const { accessToken, customer, auth } = DS_getData()
    if (accessToken == null || auth.status !== 'complete') return

    const logger = Logg_createLogger('Uplo.initialise')

    // Try catch is an added safety to make sure we don't get stuck with isProcessing set to true
    try {
        const uploadsToProcess: ProcessableUpload[] = await appUploadQueue.getUploadsToProcess()

        logger.log(`Processing ${uploadsToProcess.length} uploads`)

        // Catch and report all errors without failing the process
        await Promise.all(
            uploadsToProcess.map((upload) =>
                processUpload(
                    new ApiClient(Cust_httpUrlGet(customer), accessToken, customer.slug),
                    (chunk) => readChunk(upload.fileUploadData.fileId, chunk),
                    upload,
                    appUploadQueue,
                    logger
                ).catch(sentry.simpleError)
            )
        )
        E2E_uploadsProcessed()
    } catch (error) {
        sentry.simpleError(error)
        logger.error('getUploadsToProcess returned an error')
    }
}

export async function Uplo_initialise() {
    await Uplo_resetTransientUploads()

    window.setInterval(processUploads, 10000)

    // Cleaning up uploads once done
    appUploadQueue.subscribeToAll(async (upload) => {
        // If not done, ignore
        if (!isDone(upload)) return

        const logger = Logg_createLogger('Uplo.cleanUp')
        const { fileId } = upload.fileUploadData

        // If still in use, do not delete
        if (!upload.canBeDeletedWhenDone) {
            logger.log('upload done but not ready to be deleted', { fileId })
            return
        }

        try {
            // Otherwise, delete
            await Uplo_deleteUploads(logger, [upload])
        } catch (error) {
            logger.error(error, { fileId })
        }
    })
}
